export const CARD_MIN_HEIGHT = '200px';
